import { defineStore } from 'pinia';
import axios from 'axios';

export const usePatchNoteStore = defineStore('patchNotes', {
    state: () => ({
        activeDepartment: null,

        patchNotes: [],
        currentPatchNote: null,

        dialogOpen: false,
        loading: false,
    }),

    actions: {
        async setDepartment(department) {
            this.activeDepartment = department;

            await this.fetchPending();
        },

        async fetchPending() {
            if (!this.activeDepartment) {
                return;
            }

            this.loading = true;

            try {
                const response = await axios.get(
                    `/api/patch-notes/pending/${this.activeDepartment}`
                );

                this.patchNotes = response.data;

                this.showNext();
            } finally {
                this.loading = false;
            }
        },

        showNext() {
            if (this.patchNotes.length === 0) {
                this.currentPatchNote = null;
                this.dialogOpen = false;

                return;
            }

            this.currentPatchNote = this.patchNotes[0];
            this.dialogOpen = true;
        },

        async acknowledge() {
            if (!this.currentPatchNote) {
                return;
            }

            const patchNoteId = this.currentPatchNote.id;

            await axios.post(
                `/api/patch-notes/acknowledge/${patchNoteId}`
            );

            this.patchNotes = this.patchNotes.filter(
                note => note.id !== patchNoteId
            );

            this.currentPatchNote = null;
            this.dialogOpen = false;

            this.showNext();
        },
    },
});